
import store from '@/store/index'

export default {
  title: function (title) {
    title = title ? title.toString() : 'agility'
  },
  getToken: function (url) {
    let data = store.getters.checkData
    console.log('getToken url [' + url + '] with data', data)
    if (url && withoutFilters.indexOf(url.split('?')[0]) >= 0) {
      //在白名单中
      console.log(url + "在白名单中")
      return data?.SHAREDJSESSIONID || ''
    } else {
      if (data == undefined || data == null || Object.keys(data).length == 0 || data.expried == undefined || data.SHAREDJSESSIONID == undefined || data.expried < new Date().getTime()) {
        this.toLogin()
      } else {
        return data.SHAREDJSESSIONID
      }
    }
  },
  toLogin: function () {
    window.top.location.href = '/login'
    // let pathname = window.location.pathname
    // let path = pathname + window.location.search
    // console.log('pathname', pathname)
    // // 此部分操作是为了页面刷新的重新进入以前的链接
    // if (pathname && ['/login'].indexOf(pathname) <= 0) {
    //   localStorage.clear()
    //   window.top.location.href = path
    // }
  },
  dealUrl: function (url) {
    if (url == null || url === '') {
      return url
    }
    const index = url.indexOf('?')
    return index !== -1 ? url.substring(0, index) : url
  }
}
